<template>
<div class="container rounded bg-white mt-5 mb-5">
    <div class="wrapper bg-white mt-sm-5">
    <h4 class="pb-4 border-bottom">הגדרות הפרופיל</h4>
    <div class="d-flex align-items-start py-3 border-bottom">
        <img :src="$root.loggedUser.profileImg"
            class="img" alt="">
        <div class="pl-sm-4 pl-2" id="img-section">
            <b>תמונת הפרופיל</b>
            <p>Accepted file type .png. Less than 1MB</p>
            <button class="btn button border"><b>העלאה</b></button>
        </div>
    </div>
    <div class="py-2">
        <div class="row py-2">
            <div class="col-md-6">
                <label for="firstname">שם</label>
                <input type="text" class="bg-light form-control" placeholder="שם" v-model="$root.loggedUser.firstName">
            </div>
            <div class="col-md-6 pt-md-0 pt-3">
                <label for="lastname">שם המשפחה</label>
                <input type="text" class="bg-light form-control" placeholder="שם המשפחה" v-model="$root.loggedUser.lastName">
            </div>
        </div>
        <div class="row py-2">
            <div class="col-md-6">
                <label for="email">דואר אלקטרוני</label>
                <input type="text" class="bg-light form-control" placeholder="example@mail.com">
            </div>
            <div class="col-md-6 pt-md-0 pt-3">
                <label for="phone">סיסמה</label>
                <input type="password" class="bg-light form-control" placeholder="סיסמה" v-model="$root.loggedUser.password">
            </div>
        </div>
        <div class="row py-2">
            <div class="col-md-6">
                <label for="country">תפקיד</label>
                <select name="country" id="country" class="bg-light">
                    <option :value="$root.loggedUser.Type" selected>{{ $root.loggedUser.Type }}</option>
                    <option value="usa">USA</option>
                    <option value="uk">UK</option>
                    <option value="uae">UAE</option>
                </select>
            </div>
            <!-- <div class="col-md-6 pt-md-0 pt-3" id="lang">
                <label for="language">Language</label>
                <div class="arrow">
                    <select name="language" id="language" class="bg-light">
                        <option value="english" selected>English</option>
                        <option value="english_us">English (United States)</option>
                        <option value="enguk">English UK</option>
                        <option value="arab">Arabic</option>
                    </select>
                </div>
            </div> -->
        </div>
        <div class="py-3 pb-4 border-bottom">
            <button class="btn btn-primary mr-3">Save Changes</button>
            <button class="btn border button">Cancel</button>
        </div>
        <div class="d-sm-flex align-items-center pt-3" id="deactivate">
            <div>
                <b>Deactivate your account</b>
                <p>Details about your company account and password</p>
            </div>
            <div class="ml-auto">
                <button class="btn danger">Deactivate</button>
            </div>
        </div>
    </div>
    </div>
</div>
</template>

<script>
import { db } from '../firebase';
export default{
  name: 'Settings',
  data () {
    return {

    }
  },
  
  methods :{

    
  }
}
</script>


<style>
body{
    font-family: 'Poppins','Noto Bansa Hebrew', sans-serif;
}

.wrapper{
    padding: 30px 50px;
    border: 1px solid #ddd;
    border-radius: 15px;
    margin: 10px auto;
    max-width: 600px;
}
h4{
    letter-spacing: -1px;
    font-weight: 400;
}
.img{
    width: 70px;
    height: 70px;
    border-radius: 6px;
    object-fit: cover;
}
#img-section p,#deactivate p{
    font-size: 12px;
    color: #777;
    margin-bottom: 10px;
    text-align: justify;
}
#img-section{
    margin-right: 1rem;
}
#img-section b,#img-section button,#deactivate b{
    font-size: 14px; 
}

label{
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 500;
    color: #777;
    padding-left: 3px;
}

.form-control{
    border-radius: 10px;
}

input[placeholder]{
    font-weight: 500;
}
.form-control:focus{
    box-shadow: none;
    border: 1.5px solid #0779e4;
}
select{
    display: block;
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 10px;
    height: 40px;
    padding: 5px 10px;
    /* -webkit-appearance: none; */
}

select:focus{
    outline: none;
}
.button{
    background-color: #fff;
    color: #0779e4;
}
.button:hover{
    background-color: #0779e4;
    color: #fff;
}
.btn-primary{
    background-color: #0779e4;
}
.danger{
    background-color: #fff;
    color: #e20404;
    border: 1px solid #ddd;
}
.danger:hover{
    background-color: #e20404;
    color: #fff;
}
@media(max-width:576px){
    .wrapper{
        padding: 25px 20px;
    }
    #deactivate{
        line-height: 18px;
    }
}</style>


// WEBPACK FOOTER //
// src/pages/Settings.vue